<template>
  <section class="app-main">

    <transition name="fade-transform" mode="out-in">
      <!-- :include="cachedViews" -->
      <keep-alive   :include="cachedViews"  >
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      // ���������˵���һ�� -> Ҷ�ӣ���matched[1] ����Ҷ�ӱ�����
      // �� path ���� $route.path����Ϊ��ԭ��һ�£�
      // �������������ϣ�һ�� -> ����(empty) -> Ҷ�ӣ���matched[1] �ǹ̶�������·����
      // �Դ���Ϊ key ��������ʵ�������ȶ����Ӷ������ڲ��� keep-alive ���ܱ���Ҷ��ҳ�����ݡ�
      const matched = this.$route.matched;
      return (matched && matched[1] && matched[1].path) || this.$route.path;
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  height: calc(100vh - 132px);
  width: 100%;
  position: relative;
  overflow: hidden;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>